import React from 'react';
import ReactLoading from 'react-loading';
import "./Loading.css";

const Loading = ({width, height}) => {
    return (
        <ReactLoading className="loading-component" type="spinningBubbles" color={'#0DC4E0'} width={width} height={height} />
    )
};

export default Loading;